import dashboardRouter from './dashboardRouter';

export default dashboardRouter;
